import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import styles from "./GalleryShareSuccess.module.css";

const GallereShareSuccess = () => {
  return (
    <div>
      <Header />
      <div className={styles.mainDiv}>
        <div>
          <div
            className={`${styles.galleryShareSuccessCard} d-flex justify-content-center align-items-center`}
          >
            ギャラリーシェア　完了
          </div>
          <div className={styles.thankTxt}>thank you so much.</div>
        </div>
        <button
          className={`btn d-block m-auto ${styles.galleryShareSuccessBtn}`}
        >
          ギャラリーへ戻る
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default GallereShareSuccess;
